export const APP_RAIL_COLLAPSED_STORAGE_KEY = 'attune:app-rail-collapsed';
export const APP_RAIL_WIDTH_CSS_VARIABLE = '--attune-app-rail-width';
export const APP_RAIL_EXPANDED_WIDTH = '296px';
export const APP_RAIL_COLLAPSED_WIDTH = '0px';
export const APP_RAIL_AUTO_COLLAPSE_MEDIA_QUERY = '(max-width: 79.9975rem)';
export const APP_RAIL_COLLAPSE_REQUEST_EVENT = 'attune:app-rail-collapse-request';

export function getAppRailStateInitScript() {
  return `(()=>{try{let stored=null;try{stored=window.localStorage.getItem('${APP_RAIL_COLLAPSED_STORAGE_KEY}')}catch{}const collapsed=stored===null?window.matchMedia('${APP_RAIL_AUTO_COLLAPSE_MEDIA_QUERY}').matches:stored==='true';const root=document.documentElement;root.dataset.attuneAppRailCollapsed=String(collapsed);root.style.setProperty('${APP_RAIL_WIDTH_CSS_VARIABLE}',collapsed?'${APP_RAIL_COLLAPSED_WIDTH}':'${APP_RAIL_EXPANDED_WIDTH}')}catch{}})();`;
}

export function readAppRailCollapsedState() {
  if (typeof document === 'undefined') return false;

  const initializedValue = document.documentElement.dataset.attuneAppRailCollapsed;
  if (initializedValue) return initializedValue === 'true';

  try {
    const storedValue = window.localStorage.getItem(APP_RAIL_COLLAPSED_STORAGE_KEY);
    if (storedValue !== null) return storedValue === 'true';
  } catch {
    // Fall through to the responsive default when storage is unavailable.
  }

  return window.matchMedia(APP_RAIL_AUTO_COLLAPSE_MEDIA_QUERY).matches;
}

export function persistAppRailCollapsedState(collapsed: boolean) {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  root.dataset.attuneAppRailCollapsed = String(collapsed);
  root.style.setProperty(
    APP_RAIL_WIDTH_CSS_VARIABLE,
    collapsed ? APP_RAIL_COLLAPSED_WIDTH : APP_RAIL_EXPANDED_WIDTH
  );

  try {
    window.localStorage.setItem(APP_RAIL_COLLAPSED_STORAGE_KEY, String(collapsed));
  } catch {
    // The in-memory state and shell geometry still work when storage is unavailable.
  }
}

export function requestAppRailCollapse() {
  if (typeof window === 'undefined') return;
  persistAppRailCollapsedState(true);
  window.dispatchEvent(new Event(APP_RAIL_COLLAPSE_REQUEST_EVENT));
}
